import React, { memo } from 'react';
import PropTypes from 'prop-types';

const NavigationItem = memo(({ name, onClick }) => {
  return (
    <li
      onClick={onClick}
      className="sm:text-lg text-[13px] sm:py-3 py-2 px-4 min-w-[120px] font-medium relative group overflow-hidden
        bg-white/60 backdrop-blur-sm
        text-center text-primary-700 
        transition-all duration-300 ease-in-out
        hover:text-white hover:bg-primary-600
        first:rounded-l-md last:rounded-r-md
        border-r border-primary-200 last:border-r-0
        cursor-pointer
        transform hover:-translate-y-0.5 hover:shadow-lg hover:shadow-primary-500/20"
    >
      <span className="relative z-10">{name}</span>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-500 to-primary-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
    </li>
  );
});

NavigationItem.propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default NavigationItem; 